import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/route-patterns'

const URL_APP_ADMIN_TOOLS = `${URL_APP_ADMIN}/tools`

// Retailer-scoped (partner/warehouse) read-only Enterprise Status Page routes.
// Distinct from the admin routes above: no create-incident / user-groups.
const URL_ENTERPRISE_STATUS_PAGE = `${URL_RETAILER_SCOPED}/enterprise-status`
const URL_ENTERPRISE_STATUS_PAGE_INCIDENT_DETAILS = `${URL_ENTERPRISE_STATUS_PAGE}/incident/:incidentId`

// Enterprise Status Page Routes
const URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE = `${URL_APP_ADMIN_TOOLS}/enterprise-status-page`
const URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_CREATE_INCIDENT = `${URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE}/create-incident`
const URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_INCIDENT_DETAILS = `${URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE}/incident/:incidentId`
const URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_USER_GROUPS = `${URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE}/user-groups`

// Caper Billing Routes
const URL_APP_ADMIN_CAPER_BILLING = `${URL_APP_ADMIN_TOOLS}/caper-billing`
const URL_APP_ADMIN_CAPER_BILLING_GENERATE = `${URL_APP_ADMIN_CAPER_BILLING}/generate`
const URL_APP_ADMIN_CAPER_BILLING_HISTORY = `${URL_APP_ADMIN_CAPER_BILLING}/history`
const URL_APP_ADMIN_CAPER_BILLING_RUN_DETAIL = `${URL_APP_ADMIN_CAPER_BILLING}/history/:retailerId/:runId`

// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<
  | 'app-admin-enterprise-status-page'
  | 'app-admin-enterprise-status-page-create-incident'
  | 'app-admin-enterprise-status-page-incident-details'
  | 'app-admin-enterprise-status-page-user-groups'
  | 'enterprise-status-page'
  | 'enterprise-status-page-incident-details'
  | 'app-admin-caper-billing'
  | 'app-admin-caper-billing-generate'
  | 'app-admin-caper-billing-history'
  | 'app-admin-caper-billing-run-detail'
>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-enterprise-status-page': URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE,
  'app-admin-enterprise-status-page-create-incident':
    URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_CREATE_INCIDENT,
  'app-admin-enterprise-status-page-incident-details':
    URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_INCIDENT_DETAILS,
  'app-admin-enterprise-status-page-user-groups': URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_USER_GROUPS,
  'enterprise-status-page': URL_ENTERPRISE_STATUS_PAGE,
  'enterprise-status-page-incident-details': URL_ENTERPRISE_STATUS_PAGE_INCIDENT_DETAILS,
  'app-admin-caper-billing': URL_APP_ADMIN_CAPER_BILLING,
  'app-admin-caper-billing-generate': URL_APP_ADMIN_CAPER_BILLING_GENERATE,
  'app-admin-caper-billing-history': URL_APP_ADMIN_CAPER_BILLING_HISTORY,
  'app-admin-caper-billing-run-detail': URL_APP_ADMIN_CAPER_BILLING_RUN_DETAIL,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
